// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m7-0";
export var assigneeDetails = "_m7-1";
export var assigneeInfo = "_m7-2";
export var dropdownContainer = "_m7-4";
export var dropdownImage = "_m7-5";
export var editAssigneeInfo = "_m7-3";
export var editAssigneeModalContainer = "_m7-6";
export var hidden = "_m7-8";
export var input = "_m7-7";